import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./PhysiotherapyServices.css";
import { fetchAPI } from "../../utils/api";

const defaultPriceMap = {
  // Basic nurse
  BN001: [
    { attribute_name: "7 Days", price: "6000" },
    { attribute_name: "15 Days", price: "12000" },
    { attribute_name: "30 Days", price: "22000" },
  ],
  BN004: [
    { attribute_name: "7 Days", price: "8000" },
    { attribute_name: "15 Days", price: "16000" },
    { attribute_name: "30 Days", price: "30000" },
  ],
  BN005: [
    { attribute_name: "7 Days", price: "10500" },
    { attribute_name: "15 Days", price: "22000" },
    { attribute_name: "30 Days", price: "42000" },
  ],
  BN007: [
    { attribute_name: "7 Days", price: "18000" },
    { attribute_name: "15 Days", price: "38000" },
    { attribute_name: "30 Days", price: "72000" },
  ],

  // Critical care
  CCN001: [
    { attribute_name: "7 Days", price: "10000" },
    { attribute_name: "15 Days", price: "20000" },
    { attribute_name: "30 Days", price: "38000" },
  ],
  CCN002: [
    { attribute_name: "7 Days", price: "12000" },
    { attribute_name: "15 Days", price: "24000" },
    { attribute_name: "30 Days", price: "45000" },
  ],
  CCN003: [
    { attribute_name: "7 Days", price: "16000" },
    { attribute_name: "15 Days", price: "34000" },
    { attribute_name: "30 Days", price: "65000" },
  ],
  CCN005: [
    { attribute_name: "7 Days", price: "30000" },
    { attribute_name: "15 Days", price: "60000" },
    { attribute_name: "30 Days", price: "110000" },
  ],

  // Oncology
  ONN001: [
    { attribute_name: "7 Days", price: "9000" },
    { attribute_name: "15 Days", price: "18000" },
    { attribute_name: "30 Days", price: "35000" },
  ],
  ONN002: [
    { attribute_name: "7 Days", price: "11000" },
    { attribute_name: "15 Days", price: "22000" },
    { attribute_name: "30 Days", price: "42000" },
  ],
  ONN003: [
    { attribute_name: "7 Days", price: "15000" },
    { attribute_name: "15 Days", price: "31000" },
    { attribute_name: "30 Days", price: "60000" },
  ],
  ONN005: [
    { attribute_name: "7 Days", price: "28000" },
    { attribute_name: "15 Days", price: "55000" },
    { attribute_name: "30 Days", price: "100000" },
  ],

  // Specialized nursing
  SNP025: [
    { attribute_name: "7 Days", price: "15000" },
    { attribute_name: "15 Days", price: "30000" },
    { attribute_name: "30 Days", price: "58000" },
  ],
  SNP020: [
    { attribute_name: "7 Days", price: "14500" },
    { attribute_name: "15 Days", price: "28000" },
    { attribute_name: "30 Days", price: "55000" },
  ],
  SNP022: [
    { attribute_name: "7 Days", price: "16500" },
    { attribute_name: "15 Days", price: "32000" },
    { attribute_name: "30 Days", price: "65000" },
  ],
  SNP024: [
    { attribute_name: "7 Days", price: "15000" },
    { attribute_name: "15 Days", price: "30000" },
    { attribute_name: "30 Days", price: "58000" },
  ],
  SNP019: [
    { attribute_name: "7 Days", price: "14500" },
    { attribute_name: "15 Days", price: "28000" },
    { attribute_name: "30 Days", price: "55000" },
  ],
  SNP004: [
    { attribute_name: "7 Days", price: "18500" },
    { attribute_name: "15 Days", price: "36000" },
    { attribute_name: "30 Days", price: "72000" },
  ],
  SNP006: [
    { attribute_name: "7 Days", price: "33000" },
    { attribute_name: "15 Days", price: "65000" },
    { attribute_name: "30 Days", price: "125000" },
  ],
  SNP010: [
    { attribute_name: "7 Days", price: "16500" },
    { attribute_name: "15 Days", price: "32000" },
    { attribute_name: "30 Days", price: "65000" },
  ],
  SNP012: [
    { attribute_name: "7 Days", price: "30000" },
    { attribute_name: "15 Days", price: "58000" },
    { attribute_name: "30 Days", price: "110000" },
  ],
  SNP018: [
    { attribute_name: "7 Days", price: "14500" },
    { attribute_name: "15 Days", price: "28000" },
    { attribute_name: "30 Days", price: "55000" },
  ],
  SNP013: [
    { attribute_name: "7 Days", price: "15000" },
    { attribute_name: "15 Days", price: "30000" },
    { attribute_name: "30 Days", price: "58000" },
  ],
  SNP015: [
    { attribute_name: "7 Days", price: "28000" },
    { attribute_name: "15 Days", price: "55000" },
    { attribute_name: "30 Days", price: "105000" },
  ],
  SNP017: [
    { attribute_name: "7 Days", price: "14500" },
    { attribute_name: "15 Days", price: "28000" },
    { attribute_name: "30 Days", price: "55000" },
  ],
  SNP021: [
    { attribute_name: "7 Days", price: "13000" },
    { attribute_name: "15 Days", price: "26000" },
    { attribute_name: "30 Days", price: "50000" },
  ],
  SNP023: [
    { attribute_name: "7 Days", price: "16500" },
    { attribute_name: "15 Days", price: "32000" },
    { attribute_name: "30 Days", price: "65000" },
  ],
  SNP016: [
    { attribute_name: "7 Days", price: "14500" },
    { attribute_name: "15 Days", price: "28000" },
    { attribute_name: "30 Days", price: "55000" },
  ],
  SNP007: [
    { attribute_name: "7 Days", price: "17000" },
    { attribute_name: "15 Days", price: "34000" },
    { attribute_name: "30 Days", price: "68000" },
  ],
  SNP009: [
    { attribute_name: "7 Days", price: "31000" },
    { attribute_name: "15 Days", price: "62000" },
    { attribute_name: "30 Days", price: "120000" },
  ],
  SNP001: [
    { attribute_name: "7 Days", price: "18500" },
    { attribute_name: "15 Days", price: "36000" },
    { attribute_name: "30 Days", price: "72000" },
  ],
  SNP003: [
    { attribute_name: "7 Days", price: "33000" },
    { attribute_name: "15 Days", price: "65000" },
    { attribute_name: "30 Days", price: "125000" },
  ],

  // Bedside attendant
  ALP001: [
    { attribute_name: "7 Days", price: "5679" },
    { attribute_name: "15 Days", price: "11000" },
    { attribute_name: "30 Days", price: "21777" },
  ],
  ALP002: [
    { attribute_name: "7 Days", price: "6085" },
    { attribute_name: "15 Days", price: "11785" },
    { attribute_name: "30 Days", price: "23333" },
  ],
  ALP005: [
    { attribute_name: "7 Days", price: "6085" },
    { attribute_name: "15 Days", price: "11785" },
    { attribute_name: "30 Days", price: "23333" },
  ],
  ALP006: [
    { attribute_name: "7 Days", price: "7302" },
    { attribute_name: "15 Days", price: "14142" },
    { attribute_name: "30 Days", price: "23333" },
  ],
  ALP007: [
    { attribute_name: "7 Days", price: "7302" },
    { attribute_name: "15 Days", price: "14142" },
    { attribute_name: "30 Days", price: "23333" },
  ],
  ALP008: [
    { attribute_name: "7 Days", price: "6085" },
    { attribute_name: "15 Days", price: "11785" },
    { attribute_name: "30 Days", price: "23333" },
  ],
};

const getPackageAttributes = (pkg) => {
  if (Array.isArray(pkg.attributes) && pkg.attributes.length > 0) {
    return pkg.attributes;
  }
  const code = pkg.package_code || "";
  if (defaultPriceMap[code]) {
    return defaultPriceMap[code];
  }
  const basePrice = parseFloat(pkg.sale_price || pkg.price || 0);
  if (basePrice > 0) {
    return [
      { attribute_name: "7 Days", price: String(basePrice) },
      { attribute_name: "15 Days", price: String(Math.round(basePrice * 2)) },
      { attribute_name: "30 Days", price: String(Math.round(basePrice * 3.8)) },
    ];
  }
  return [
    { attribute_name: "7 Days", price: "8000" },
    { attribute_name: "15 Days", price: "16000" },
    { attribute_name: "30 Days", price: "30000" },
  ];
};

function PhysiotherapyServices({ serviceId = 2, searchQuery = "" }) {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [selectedCategoryName, setSelectedCategoryName] = useState("");
  const [selectedService, setSelectedService] = useState(null);
  const [loading, setLoading] = useState(true);
  const [selectedDaysMap, setSelectedDaysMap] = useState({});

  useEffect(() => {
    setLoading(true);
    fetchAPI("CaregiverController/packages", {
      method: "POST",
      body: JSON.stringify({ service_id: serviceId, service_type_id: 2 }),
    })
      .then((data) => {
        if (
          data &&
          (data.status == 200 || data.status === 200) &&
          Array.isArray(data.result)
        ) {
          let catList = data.result;
          const mapped = catList.map((cat) => {
            let catPackages = (cat.packages || []).map((pkg) => {
              const attrs = getPackageAttributes(pkg);
              return {
                ...pkg,
                attributes: attrs,
              };
            });

            if (serviceId === 1 || serviceId === 3) {
              const titleGroups = {};
              catPackages.forEach((pkg) => {
                const t = pkg.package_title || "Package";
                if (!titleGroups[t]) titleGroups[t] = [];
                titleGroups[t].push(pkg);
              });

              const orderedPackages = [];
              Object.keys(titleGroups).forEach((titleKey) => {
                const pkgs = titleGroups[titleKey];
                pkgs.sort((a, b) => {
                  const pa = parseFloat(
                    a.attributes?.[0]?.price || a.sale_price || a.price || 0,
                  );
                  const pb = parseFloat(
                    b.attributes?.[0]?.price || b.sale_price || b.price || 0,
                  );
                  return pa - pb;
                });

                const shifts4 = ["6 Hours", "8 Hours", "12 Hours", "24 Hours"];
                const shifts2 = ["12 Hours", "24 Hours"];

                pkgs.forEach((pkg, idx) => {
                  let shiftStr = "12 Hours";
                  if (pkgs.length === 4) {
                    shiftStr = shifts4[idx];
                  } else if (pkgs.length === 2) {
                    shiftStr = shifts2[idx];
                  } else if (pkg.duration && pkg.duration !== "-") {
                    shiftStr = pkg.duration;
                  }
                  pkg._assignedShift = shiftStr;
                  orderedPackages.push(pkg);
                });
              });
              catPackages = orderedPackages;
            }

            return {
              id: cat.package_category_id,
              name: cat.package_category_title,
              count: catPackages.length,
              services: catPackages.map((pkg) => {
                const attrs = pkg.attributes || [];
                const firstAttrPrice =
                  parseFloat(
                    attrs?.[0]?.price || pkg.sale_price || pkg.price || 1999,
                  ) || 1999;
                return {
                  id: pkg.package_id,
                  name: pkg.package_title,
                  duration:
                    pkg.duration && pkg.duration !== "-"
                      ? pkg.duration
                      : "12 Hours",
                  shiftDuration:
                    pkg._assignedShift ||
                    (pkg.duration && pkg.duration !== "-"
                      ? pkg.duration
                      : "12 Hours"),
                  price: firstAttrPrice,
                  attributes: attrs,
                  rawPackage: pkg,
                  subtitle: pkg.package_subtitle,
                };
              }),
            };
          });
          setCategories(mapped);
          if (mapped.length > 0) {
            setSelectedCategoryName(mapped[0].name);
          }
        }
      })
      .catch((err) => {
        console.error("Error loading packages dynamically:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [serviceId]);

  const getServiceDays = (service) => {
    if (selectedDaysMap[service.id]) {
      return selectedDaysMap[service.id];
    }
    if (service.attributes && service.attributes.length > 0) {
      const firstAttr = service.attributes[0];
      const match = String(firstAttr.attribute_name).match(/\d+/);
      if (match) return parseInt(match[0]);
    }
    return 7;
  };

  const getComputedPrice = (service, days) => {
    if (
      service &&
      service.attributes &&
      Array.isArray(service.attributes) &&
      service.attributes.length > 0
    ) {
      const targetAttr = service.attributes.find((attr) => {
        const numMatch = String(attr.attribute_name).match(/\d+/);
        return numMatch && parseInt(numMatch[0]) === parseInt(days);
      });
      if (targetAttr && targetAttr.price) {
        const parsedP = parseFloat(String(targetAttr.price).replace(/,/g, ""));
        if (!isNaN(parsedP) && parsedP > 0) {
          return parsedP;
        }
      }
    }
    const base = service?.price || 1999;
    return Math.round((base / 7) * days);
  };

  const handleSelectService = (service, chosenDays, shouldNavigate = false) => {
    setSelectedService(service);
    const computedPrice = getComputedPrice(service, chosenDays);
    const shiftStr = service.shiftDuration || service.duration || "12 Hours";
    const durationStr = `${chosenDays} Days (${shiftStr})`;
    const categoryType = serviceId === 2 ? "physiotherapy" : "nursing";
    try {
      localStorage.setItem("selectedDuration", `${chosenDays} Days`);
      localStorage.setItem("selectedShift", shiftStr);
      localStorage.setItem("selectedServiceCategory", categoryType);
      const longTermItem = {
        id: service.id,
        name: service.name,
        duration: durationStr,
        selectedDays: chosenDays,
        selectedShift: shiftStr,
        price: `₹${computedPrice}`,
        offer: "Special Price",
        type: "longterm",
        serviceId: serviceId,
        serviceCategory: categoryType,
        attributes: service.attributes || [],
      };
      // Long term services go directly to booking/careplan, not to the short term cart
      localStorage.setItem("selectedLongTerm", JSON.stringify(longTermItem));
    } catch (err) {
      console.error("Error updating long term selection:", err);
    }
    if (shouldNavigate) {
      window.location.href = "/careplan";
    }
  };

  const servicesRef = useRef(null);

  const handleCategoryClick = (categoryName) => {
    setSelectedCategoryName(categoryName);

    if (window.innerWidth <= 767) {
      setTimeout(() => {
        servicesRef.current?.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }, 100);
    }
  };

  const query = (searchQuery || "").toLowerCase().trim();

  const filteredCategories = categories
    .map((cat) => {
      const catName = (cat.name || "").toLowerCase();
      const isCatMatch = catName.includes(query);

      const matchedServices = (cat.services || []).filter((s) => {
        const sName = (s.name || "").toLowerCase();
        return isCatMatch || sName.includes(query);
      });

      if (matchedServices.length > 0) {
        return {
          ...cat,
          count: matchedServices.length,
          services: matchedServices,
        };
      }
      return null;
    })
    .filter(Boolean);

  const displayCategories = query ? filteredCategories : categories;

  const activeCategoryObj = displayCategories.find(
    (c) => c.name === selectedCategoryName,
  ) ||
    displayCategories[0] || {
      name: selectedCategoryName || "Services",
      count: 0,
      services: [],
    };

  const activeServices = activeCategoryObj.services || [];

  return (
    <section className="physio-section">
      <div className="row g-3">
        {/* ================= SIDEBAR ================= */}

        <div className="col-lg-3 col-xl-3">
          <div className="category-sidebar">
            <h4 className="sidebar-title">All Categories</h4>

            <div className="category-list">
              {loading ? (
                <div className="p-3 text-muted small">
                  Loading categories...
                </div>
              ) : (
                displayCategories.map((category) => (
                  <button
                    type="button"
                    key={category.id || category.name}
                    className={`category-item ${
                      activeCategoryObj.name === category.name ? "active" : ""
                    }`}
                    onClick={() => handleCategoryClick(category.name)}
                  >
                    <span className="category-name">{category.name}</span>

                    <span className="category-count">{category.count}</span>
                  </button>
                ))
              )}
            </div>
          </div>
        </div>

        {/* ================= SERVICES ================= */}

        <div className="col-lg-9 col-xl-9">
          <div className="services-wrapper" ref={servicesRef}>
            {/* Header */}

            <div className="services-header">
              <div>
                <h2>{activeCategoryObj.name}</h2>
              </div>

              <span className="service-count">
                {activeCategoryObj.count} Services
              </span>
            </div>

            {/* Service Grid */}

            <div className="row g-4">
              {loading ? (
                <div className="col-12 text-center py-5">
                  <h4 style={{ color: "#13baac" }}>Loading services...</h4>
                </div>
              ) : activeServices.length === 0 ? (
                <div className="col-12 text-center py-5">
                  <h5 className="text-muted">
                    No services found in this category.
                  </h5>
                </div>
              ) : (
                activeServices.map((service) => {
                  const isSelected = selectedService?.id === service.id;
                  const currentDays = getServiceDays(service);
                  const computedPrice = getComputedPrice(service, currentDays);
                  const displayShift =
                    serviceId === 1 || serviceId === 3
                      ? service.shiftDuration
                      : service.duration;

                  return (
                    <div className="col-md-6 col-xl-6" key={service.id}>
                      <div
                        className={`service-card ${isSelected ? "selected" : ""}`}
                        onClick={() =>
                          handleSelectService(service, currentDays, false)
                        }
                      >
                        {/* ================= CARD HEADER ================= */}

                        <div className="service-card-header">
                          <div className="service-radio">
                            <input
                              type="radio"
                              name="physio-service"
                              checked={isSelected}
                              onChange={() =>
                                handleSelectService(service, currentDays, false)
                              }
                              onClick={(e) => e.stopPropagation()}
                            />
                          </div>
                          <div>
                            <h5>{service.name}</h5>
                          </div>
                        </div>

                        {/* ================= CARD BODY ================= */}

                        <div className="service-card-body">
                          <p className="service-desc">{service.subtitle}</p>
                          <div className="service-info">
                            {/* Duration / Shift */}

                            <div className="service-meta">
                              <small>Duration : </small>
                              <span>{displayShift}</span>
                            </div>

                            {/* DYNAMIC PRICE */}

                            <div className="service-price">
                              ₹{Math.round(computedPrice)}
                            </div>
                          </div>

                          {/* ================= DURATION SELECTION ================= */}

                          <div className="duration-section">
                            <div className="w-100 d-flex justify-content-between align-items-center">
                              <div className="duration-options">
                                {service.attributes &&
                                service.attributes.length > 0 ? (
                                  service.attributes.map((attr, idx) => {
                                    const daysNum = parseInt(
                                      String(attr.attribute_name).match(
                                        /\d+/,
                                      )?.[0] || 7,
                                    );
                                    const isActive = currentDays === daysNum;
                                    return (
                                      <span
                                        key={attr.attribute_value_id || idx}
                                        className={`duration-btn ${isActive ? "active" : ""}`}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          setSelectedDaysMap((prev) => ({
                                            ...prev,
                                            [service.id]: daysNum,
                                          }));
                                        }}
                                      >
                                        {attr.attribute_name}
                                      </span>
                                    );
                                  })
                                ) : (
                                  <>
                                    <span
                                      className={`duration-btn ${currentDays === 7 ? "active" : ""}`}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setSelectedDaysMap((prev) => ({
                                          ...prev,
                                          [service.id]: 7,
                                        }));
                                      }}
                                    >
                                      7 Days
                                    </span>
                                    <span
                                      className={`duration-btn ${currentDays === 15 ? "active" : ""}`}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setSelectedDaysMap((prev) => ({
                                          ...prev,
                                          [service.id]: 15,
                                        }));
                                      }}
                                    >
                                      15 Days
                                    </span>
                                    <span
                                      className={`duration-btn ${currentDays === 30 ? "active" : ""}`}
                                      onClick={(e) => {
                                        e.stopPropagation();
                                        setSelectedDaysMap((prev) => ({
                                          ...prev,
                                          [service.id]: 30,
                                        }));
                                      }}
                                    >
                                      30 Days
                                    </span>
                                  </>
                                )}
                              </div>

                              <div className="card-action">
                                {isSelected ? (
                                  <button
                                    type="button"
                                    className="add-btn added"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleSelectService(
                                        service,
                                        currentDays,
                                        true,
                                      );
                                    }}
                                  >
                                    ✓ Booked
                                  </button>
                                ) : (
                                  <button
                                    type="button"
                                    className="add-btn"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleSelectService(
                                        service,
                                        currentDays,
                                        true,
                                      );
                                    }}
                                  >
                                    + Book
                                  </button>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default PhysiotherapyServices;
